<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="medical_examination"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hideAddButton="true"
      @view="showEditModal($event.id)"
    />

    <medical-examination-preview-modal :show="showModal" @close="hideModal" />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import MedicalExaminationPreviewModal from '@/components/modals/MedicalExaminationPreviewModal';
import { listMixin } from '@/mixins/list';
import { VIEW_ACTION } from '@/utils/constants';

// @vuese
// Lista badań lekarskich użytkownika
// @group Profile
export default {
  mixins: [
    listMixin('profile/medicalExamination', {
      listError: 'messages.medicalExamination.listError',
      getError: 'messages.medicalExamination.getError',
      added: 'messages.medicalExamination.added',
      addError: 'messages.medicalExamination.addError',
      updated: 'messages.medicalExamination.updated',
      updateError: 'messages.medicalExamination.updateError',
      deleteConfirm: 'messages.medicalExamination.deleteConfirm',
      deleted: 'messages.medicalExamination.deleted',
      deleteError: 'messages.medicalExamination.deleteError'
    })
  ],
  components: { ComponentTable, MedicalExaminationPreviewModal },

  data() {
    return {
      columns: [
        { name: 'name', displayName: 'columns.name' },
        { name: 'dateEnd', displayName: 'columns.expirationDate', sortable: 'true', sortName: 'end' },
        { name: 'teamName', displayName: 'columns.deliveredTeam' }
      ],
      actions: [{ ...VIEW_ACTION, icon: 'fal fa-fw fa-search' }]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.profile.medicalExamination.list.map(medicalExamination => ({
          ...medicalExamination,
          teamName: medicalExamination.team.name,
          dateEnd: moment(medicalExamination.end).format('DD-MM-Y')
        })),
      count: state => state.profile.medicalExamination.count
    })
  }
};
</script>
